// extracted by mini-css-extract-plugin
export default {"commentItem":"CommentsBlock_commentItem__Dmb7V","editButtons":"CommentsBlock_editButtons__Vcojr"};